module.exports = __webpack_public_path__ + "static/media/phoneDark.359eb130.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Header/components/Title/Icons/phoneDark.svg
// module id = 75
// module chunks = 0